import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PartnerInGroundAndConstruction() {
  const {
    ref: titleRef,
    isVisible: titleVisible
  } = useRevealOnScroll();
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  const {
    ref: btnRef,
    isVisible: btnVisible
  } = useRevealOnScroll();
  return <section data-section-id="58183" id="inspiration-hero" className="dark bg-background text-foreground relative flex min-h-[85vh] w-full items-center justify-center overflow-hidden py-20">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626429/img/bathroom_inspiration_hero.png" alt="Exklusiv badrumsdesign i skandinavisk stil" className="h-full w-full object-cover object-center" />
        {}
        <div className="absolute inset-0 bg-black/40 bg-gradient-to-b from-black/30 via-transparent to-black/20 mix-blend-multiply" />
        <div className="absolute inset-0 bg-black/20" /> {}
      </div>

      {}
      <div className="relative z-10 mx-auto flex max-w-4xl flex-col items-center px-4 text-center">
        <h1 ref={titleRef} className={`font-default text-5xl font-bold tracking-tight text-white transition-all duration-1000 ease-out md:text-7xl ${titleVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`} style={{
        letterSpacing: "-0.02em"
      }}>Badrumsinspiration<br />för ditt hem</h1>

        <p ref={textRef} className={`mt-6 max-w-2xl font-default text-lg text-gray-100 transition-all delay-200 duration-1000 ease-out md:text-2xl ${textVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>Hitta inspiration till ditt nya badrum med smarta lösningar, genomtänkta materialval och tidlös design. Utforska idéer för både små och stora badrum och upptäck möjligheterna inför din renovering.</p>

        <div ref={btnRef} className={`mt-10 transition-all delay-500 duration-1000 ease-out ${btnVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <div className="relative inline-flex group">
            {}
            <div className="absolute -inset-1 animate-ping rounded-md bg-primary/40 opacity-75 duration-1000" />
            
            <Button asChild size="lg" className="relative h-auto rounded-md bg-primary px-10 py-5 text-lg font-semibold text-primary-foreground shadow-lg transition-transform hover:scale-105 hover:bg-primary/90">
              <Link to="/offertforfragan">
                Begär offert
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}